import debounce from 'lodash/debounce'
import { makeAutoObservable } from 'mobx'
import { enableStaticRendering } from 'mobx-react'
// eslint-disable-next-line react-hooks/rules-of-hooks
enableStaticRendering(typeof window === 'undefined')

class UIStore {
  constructor() {
    makeAutoObservable(this)

    this.setWindow()
    this.setScroll()
    this.setMouseMove()
  }

  // Window size
  screenWindow = null

  setWindow = () => {
    // make sure the window is available
    if (typeof window === 'object') {
      this.screenWindow = window
      this.handleWindowSizeChange()
      this.screenWindow.addEventListener('resize', this.handleWindowSizeChange)
    }
  }

  windowWidth = null

  setWindowWidth = width => {
    this.windowWidth = width
    return this.windowWidth
  }

  windowHeight = null

  setWindowHeight = height => {
    this.windowHeight = height
    return this.windowHeight
  }

  handleWindowSizeChange = debounce(() => {
    if (!this.screenWindow) return

    const width = this.screenWindow.innerWidth
    this.setWindowWidth(width)
    const height = this.screenWindow.innerHeight
    this.setWindowHeight(height)
  }, 100)

  get isMobile() {
    return this.windowWidth < 420
  }

  get isSmallerThanTablet() {
    return this.windowWidth < 768
  }

  get isSmallerThanDesktop() {
    return this.windowWidth < 1024
  }

  // Mouse pointer
  setMouseMove = () => {
    // make sure the window is available
    if (typeof window === 'object') {
      document.addEventListener('mousemove', this.handleMouseMove)
    }
  }

  mousePosition = { x: 0, y: 0 }

  handleMouseMove = debounce(event => {
    this.mousePosition = { x: event.clientX, y: event.clientY }
  }, 0)

  get relativeMousePosition() {
    return {
      x: this.mousePosition.x / this.windowWidth,
      y: this.mousePosition.y / this.windowHeight,
    }
  }

  get relativeCenterMousePosition() {
    return {
      x: ((this.mousePosition.x - this.windowWidth / 2) / this.windowWidth) * 2,
      y:
        ((this.mousePosition.y - this.windowHeight / 2) / this.windowHeight) *
        2,
    }
  }

  // Scrolling
  scrollDistance = 0

  scrollDirection = 'down'

  setScroll = () => {
    const handleScroll = () => {
      if (document.body.getBoundingClientRect().top > -this.scrollDistance) {
        this.scrollDirection = 'up'
      } else {
        this.scrollDirection = 'down'
      }

      this.scrollDistance = document.body.getBoundingClientRect().top * -1
    }

    if (typeof window === 'object') {
      window.addEventListener('scroll', handleScroll, {
        capture: false,
        passive: true,
      })
    }
  }

  // Header
  get isHeaderCompact() {
    return this.scrollDistance > 60 || this.isSearchOpen
  }

  get isHeaderPinned() {
    return (
      (this.scrollDirection === 'down' && this.scrollDistance <= 60) ||
      this.scrollDirection === 'up'
    )
  }

  // Search
  isSearchOpen = false

  setIsSearchOpen = value => {
    if (value && this.isMenuOpen) this.setIsMenuOpen(false)
    this.isSearchOpen = value
  }

  // Loading
  isLoading = true

  setIsLoading = value => {
    this.isLoading = value
  }

  // Pages
  currentPage = null

  setCurrentPage = value => {
    this.currentPage = value
  }

  // Banner
  showBanner = true

  setShowBanner = value => {
    this.showBanner = value
  }

  // Search
  showSearch = true

  setShowSearch = value => {
    this.showSearch = value
  }

  searchQuery = ''

  setSearchQuery = value => {
    this.searchQuery = value
  }

  searchResults = []

  setSearchResults = value => {
    this.searchResults = value
  }
}

export default UIStore
